/**
 * Created by Iman on 04/01/2025.
 */

import axios from "axios"
import { useAuthStore } from "@/store/auth"
import router from "./router/index.js"

const axiosClient = axios.create({
  // baseURL: "http://eco-food-app.test/api/v1",
  baseURL: "https://api.ghazachi.co/api/v1",
})

axiosClient.interceptors.request.use((config) => {
  const authStore = useAuthStore()
  const token = authStore.user.token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

axiosClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response.status === 401) {
      const authStore = useAuthStore()
      authStore.setAccessToken(null)
      router.push({ name: "login" })
    }
    throw error
  },
)

export default axiosClient
